module.exports = __webpack_public_path__ + "img/about_cover.a8ed78c4.jpg";